(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderChangeUnderwriterDialogController', AppraisalOrderChangeUnderwriterDialogController);

    AppraisalOrderChangeUnderwriterDialogController.$inject = ['$mdDialog', 'appraisalOrder', 'AppraisalOrder', 'LenderContact'];

    function AppraisalOrderChangeUnderwriterDialogController ($mdDialog, appraisalOrder, AppraisalOrder, LenderContact) {
        var vm = this;
        vm.appraisalOrder = appraisalOrder;
        vm.currentUnderwriter = appraisalOrder.lenderUnderwriterContact;
        vm.currentUnderwriterLabel = vm.currentUnderwriter
            ? vm.currentUnderwriter.contact.firstName + ' ' + vm.currentUnderwriter.contact.lastName
                + ' (' + vm.currentUnderwriter.contact.emailAddress + ')'
            : 'None';
        vm.lenderContacts = [];
        vm.contactsLoaded = false;
        vm.selectedContact = null;
        vm.isSaving = false;

        vm.save = save;
        vm.cancel = cancel;

        // Enabled contacts of the order's lender, without the current underwriter.
        LenderContact.getEnabledByLender({id: vm.appraisalOrder.lender.id}).$promise.then(function(contacts) {
            var currentId = vm.currentUnderwriter ? vm.currentUnderwriter.id : null;
            vm.lenderContacts = contacts.filter(function(contact) {
                return contact.id !== currentId;
            }).sort(function(a, b) {
                return contactLabel(a).localeCompare(contactLabel(b));
            });
            vm.contactsLoaded = true;
        });

        function contactLabel(contact) {
            return contact.firstName + ' ' + contact.lastName + ' (' + contact.email + ')';
        }

        function save() {
            vm.isSaving = true;
            AppraisalOrder.changeUnderwriter({id: vm.appraisalOrder.id}, {
                lenderContactId: vm.selectedContact.id,
                reason: vm.reason
            }, function(response) {
                $mdDialog.hide({id: vm.appraisalOrder.id});
            }, function(error) {
                vm.isSaving = false;
                // A 400 carries its message in a header that the error interceptor already shows.
                if (!error.headers('X-valueconnectApp-error')) {
                    $mdDialog.cancel({error: "Couldn't change the underwriter. Please try again."});
                }
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
